var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 12,
  viewBox: "0 0 14 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m.99 6.005 4.029.5c.547 0 .99.443.99.999 0 .551-.443.999-1.009.999l-1.465-.5a4.001 4.001 0 0 0 7.339-1h2.043A6 6 0 0 1 7 12a6 6 0 0 1-5-2.68l.5 1.671a1 1 0 0 1-2 .019L0 6.995c0-.547.451-.99.99-.99M12.5 0a1 1 0 0 1 1 .99l.5 4.025c0 .546-.451.99-.99.99L9 5.505a.993.993 0 0 1-.99-1c0-.551.443-.998 1.009-.998l1.446.5a4.001 4.001 0 0 0-7.339 1v-.002H1.083A6 6 0 0 1 7 .01a6 6 0 0 1 5 2.68l-.5-1.68c0-.557.444-1.009 1-1.009"
})));
export default SvgRefresh;